import React from 'react';
import './Shimmer.css'; // Create a CSS file for styling

const Shimmer = ({ count = 3, height = '600px', width = '100%' }) => {
  const slides = Array.from({ length: count });

  return (
    <div className="shimmer-carousel-container" style={{ height, width, position: 'relative', overflow: 'hidden' }}>
      {slides.map((_, index) => (
        <div key={index} className="shimmer-slide">
          <div className="shimmer-effect"></div>
        </div>
      ))}
    </div>
  );
};

export default Shimmer;